module.exports = __webpack_public_path__ + "static/media/logo.3eacc0ee.png";